import BorderDrawer from '@/utils/map/BorderDrawer'
import { OBJECT } from '@/utils/map/types'
import PopupCreator from '@/utils/map/PopupCreator'
import { getValueInObjectByPath } from '@/utils/getValueInObjectByPath'

const DEFAULT_POPUP = {
  head: 'Зона действия',
  fields: [
    { value: 'apoName', label: 'Наименование' },
    { value: 'operatorName', label: 'Региональный оператор' },
  ],
}

export default class MappingBorderDrawer extends BorderDrawer {
  constructor(map, vm) {
    super(map, vm)
    this.popupCreator = new PopupCreator(vm)
  }

  bringToBack() {
    for (let key in this.__polygons) {
      this.__polygons[key].bringToBack()
    }
  }

  bringToFront() {
    for (let key in this.__polygons) {
      this.__polygons[key].bringToFront()
    }
  }

  attachPopups(obj = {}) {
    const popup = obj?.popup || DEFAULT_POPUP
    // подсчет суммы всех отходов по зоне оператора
    // чисто для кургана было сделано

    try {
      const apoSum = {}
      const apoSumCub = {}
      for (let key in this.__polygons) {
        if (this.__polygons[key].options.item.apo_id) {
          const apoId = this.__polygons[key].options.item.apo_id
          if (!apoSum[apoId]) {
            apoSum[apoId] = 0
          }
          if (!apoSumCub[apoId]) {
            apoSumCub[apoId] = 0
          }
          // apoTotalGarbageSum
          if (this.__polygons[key].options.item.total_garbage) {
            apoSum[apoId] += +this.__polygons[key].options.item.total_garbage
          }
          if (this.__polygons[key].options.item.total_garbage_cubic) {
            apoSumCub[apoId] +=
              +this.__polygons[key].options.item.total_garbage_cubic
          }
        }
      }

      for (let key in this.__polygons) {
        if (this.__polygons[key].options.item.apo_id) {
          const apoId = this.__polygons[key].options.item.apo_id
          this.__polygons[key].options.item.apoTotalGarbageSum =
            apoSum[apoId] || null
          this.__polygons[key].options.item.apoTotalGarbageCubicSum =
            apoSumCub[apoId] || null
          if (this.__polygons[key].options.item.apoTotalGarbageSum) {
            this.__polygons[key].options.item.apoTotalGarbageSum =
              this.__polygons[key].options.item.apoTotalGarbageSum.toFixed(1)
          }
          if (this.__polygons[key].options.item.apoTotalGarbageCubicSum) {
            this.__polygons[key].options.item.apoTotalGarbageCubicSum =
              this.__polygons[key].options.item.apoTotalGarbageCubicSum.toFixed(
                1
              )
          }
          if (this.__polygons[key].options.item.disableHarcodedSumOnFront) {
            console.warn('Используется захардкоженная сумма отходов')
            this.__polygons[key].options.item.apoTotalGarbageSum = '225157,1'
            this.__polygons[key].options.item.apoTotalGarbageCubicSum =
              '1482019,1'
          }
        }
      }
    } catch (e) {
      console.warn('Расчет суммы всех отходов по зоне оператора накрылся', e)
    }

    for (let key in this.__polygons) {
      if (this.__polygons[key].options.item) {
        // какие поля добавлять, чтобы не тащить большие полигоны через все
        const attachFields = popup.fields.reduce((obj, { value: fName }) => {
          if (this.__polygons[key].options.item.hasOwnProperty(fName)) {
            obj[fName] = this.__polygons[key].options.item[fName]
          }
          if (
            !this.__polygons[key].options.item[fName] ||
            this.__polygons[key].options.item[fName] === '-' ||
            parseFloat(
              this.__polygons[key].options.item.hasOwnProperty(fName)
            ) === 0
          ) {
            delete this.__polygons[key].options.item[fName]
            this.__polygons[key].options?.model?.model?.[fName] &&
              delete this.__polygons[key].options.model.model[fName]
          }
          return obj
        }, {})

        this.__polygons[key].options.model = {
          model: {
            id: getValueInObjectByPath(
              'tkoOperator.id',
              this.__polygons[key].options.item
            ),
            operatorName: getValueInObjectByPath(
              'tkoOperator.name',
              this.__polygons[key].options.item
            ),
            apoName: getValueInObjectByPath(
              'apo.name',
              this.__polygons[key].options.item
            ),
            ...attachFields,
          },
          ...popup,
        }

        if (this.__polygons[key].options.model.model) {
          this.createLocalityPopup(this.__polygons[key])
        }
      }
    }
  }

  detachPopups() {
    for (let key in this.__polygons) {
      this.__polygons[key].off('click')
    }
  }

  createLocalityPopup(l) {
    try {
      let options = {}
      if (l?.options?.model?.model?.id) {
        options.redirectParams = {
          name: 'geo.objects.operator.update',
          params: {
            id: l?.options?.model?.model?.id,
          },
        }
      }
      let popup = this.popupCreator.getPopup(
        l,
        OBJECT.OFFLINE,
        l?.options?.model?.model?.id,
        options
      )
      l.bindPopup(popup)
      l.on('click', () => {
        this.vm.$emitter.emit('eqClickPolygon', l)
        l?._popup.openPopup()
      })
    } catch (e) {
      console.error(e)
      this.vm.$e.errorBox(e)
    }
  }
}
